import $ from 'jquery';
import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

export default {
    init () {
        // JavaScript to be fired on the about us page
        console.log('products');

        let productSwiper = new Swiper('.swiper-container',
            {
                hashNavigation: true,
                navigation: {
                    nextEl: '.btn-next',
                    prevEl: '.btn-prev'
                },

                slidesPerView: 1,

                breakpoints: {
                    // when window width is >= 320px
                    // when window width is >= 480px
                    640: { slidesPerView: 2 },
                    // when window width is >= 640px
                    768: { slidesPerView: 3 },
                    992: { slidesPerView: 4 }
                }
            }
        );

        if (window.location.hash) {
            $('.block-products-section' + window.location.hash)
                .fadeIn();
            $('.block-push--item a[href="' + window.location.hash + '"]')
                .addClass('active');
            let slideIndex = $('a[href="' + window.location.hash + '"]').parent('.block-push--item')
                .index();

            productSwiper.slideTo(slideIndex, 100, false);
        } else {
            $('.block-products-section').eq(0)
                .fadeIn();
            $('.block-push--item a').eq(0)
                .addClass('active');
        }

        $('.block-push--item a').each(function () {
            $(this).click(function () {
                const _anchor = $(this).attr('href');

                $('.block-products-section').hide();
                $(_anchor).fadeIn();

                $('.block-push--item a').removeClass('active');
                $(this).addClass('active');

                console.log(_anchor);
            })
        });
    }
}
